import { PaymentAPI as t } from "../paymentApi.js";
import { DummyPaymentProcess as n } from "./dummy.process.js";
class s extends n {
  constructor(e) {
    super({
      ...e,
      engine: t.PaymentMethodEngine.CASHBACK
    });
  }
  async executePayment(e) {
    if (this.configuration.amount + this.configuration.tip - this.configuration.cashback > 0)
      throw new Error("Invalid cashback amount values");
    return super.executePayment(e);
  }
}
export {
  s as CashbackProcess
};
//# sourceMappingURL=cashback.process.js.map
